import React from 'react';
import {FormattedMessage} from "react-intl";
import styles from "./styles.module.scss";

export function StatusColumnFormatter(statusID: number, statusText: string) {
  const prefix = 'notifications-status-type';
  const getProps = () => {
    switch (statusID) {
      case 1:
        return {
          styles: {
            background: '#F9F4E5',
            border: '1px solid rgb(253, 185, 19)',
            color: 'rgb(253, 185, 19)',
          },
          label: <FormattedMessage id={`${prefix}-pending`} defaultMessage={'Pending'}/>
        };
      case 2:
        return {
          styles: {
            background: '#F2E6E6',
            border: '1px solid rgb(239, 65, 48)',
            color: 'rgb(239, 65, 48)',
          },
          label: <FormattedMessage id={`${prefix}-fail`} defaultMessage={'Fail'}/>
        };
      case 3:
        return {
          styles: {
            background: '#CDEADB',
            border: '1px solid rgb(65, 141, 88)',
            color: 'rgb(65, 141, 88)',
          },
          label: <FormattedMessage id={`${prefix}-success`} defaultMessage={'Success'}/>
        };
      default:
        return {
          styles: {
            background: 'transparent'
          },
          label: ''
        };
    }
  };

  return (
    <div className={styles.tooltip}>
      <div
        className={"badge badge-pill w-150px font-size-h4 text-nowrap position-relative"}
        style={getProps().styles}
      >
        {getProps().label}
      </div>
      {statusText && <span className={styles.tooltipText} style={getProps().styles}>
        {statusText}</span>}
    </div>
  )
}
